import Vue from 'vue'
import defaultState from './state'

export default {
  setMileageCategories (state, payload) {
    if (state.mileageCategoriesCurrentPage === 1) {
      state.mileageCategories = payload
    } else {
      state.mileageCategories.push(...payload)
    }
  },
  setMileageCategoriesFilters: (state, payload) => { state.mileageCategoriesFilters = payload },
  setMileageCategoriesLastPage: (state, payload) => { state.mileageCategoriesLastPage = payload },
  incrementMileageCategoriesCurrentPage: (state, payload) => { state.mileageCategoriesCurrentPage++ },
  addMileageCategory: (state, payload) => {
    const { id } = payload
    const mileageCategoryToFindIndex = state.mileageCategories.findIndex(el => el.id === id)
    if (mileageCategoryToFindIndex !== -1) {
      state.mileageCategories.splice(mileageCategoryToFindIndex, 1, payload)
    } else {
      state.mileageCategories.push(payload)
    }
  },
  deleteMileageCategory: (state, id) => {
    const mileageCategoryToFindIndex = state.mileageCategories.findIndex(el => el.id === id)
    state.mileageCategories.splice(mileageCategoryToFindIndex, 1)
  },

  setDietCategories: (state, payload) => {
    if (state.dietCategoriesCurrentPage === 1) {
      state.dietCategories = payload
    } else {
      state.dietCategories.push(...payload)
    }
  },
  setDietCategoriesFilters: (state, payload) => { state.dietCategoriesFilters = payload },
  setDietCategoriesLastPage: (state, payload) => { state.dietCategoriesLastPage = payload },
  incrementDietCategoriesCurrentPage: (state, payload) => { state.dietCategoriesCurrentPage++ },
  addDietCategory: (state, payload) => {
    const { id } = payload
    const dietCategoryToFindIndex = state.dietCategories.findIndex(el => el.id === id)
    if (dietCategoryToFindIndex !== -1) {
      state.dietCategories.splice(dietCategoryToFindIndex, 1, payload)
    } else {
      state.dietCategories.push(payload)
    }
  },
  deleteDietCategory: (state, id) => {
    const dietCategoryToFindIndex = state.dietCategories.findIndex(el => el.id === id)
    state.dietCategories.splice(dietCategoryToFindIndex, 1)
  },

  setIsCallingExpenses: (state, payload) => { state.isCallingExpenses = payload },

  clearStoreData: state => {
    const initialState = defaultState.getDefaultState()
    Object.keys(initialState).forEach(key => {
      Vue.set(state, key, initialState[key])
    })
  }

}
